import React from "react";
import { Link } from "react-router-dom";
import "./NotFound.scss";

const NotFound = () => {
  return (
    <div className="not-found-container">
      <div className="not-found-card text-center">
        <div className="not-found-badge">
          <i className="bi bi-exclamation-triangle-fill text-warning fs-5"></i>
          <span>Lỗi 404 - Không tìm thấy trang</span>
        </div>
        <h1 className="not-found-code">404</h1>
        <h2 className="not-found-title">Trang Bạn Tìm Kiếm Không Tồn Tại</h2>
        <p className="not-found-desc">
          Đường dẫn có thể bị hỏng, trang đã bị thay đổi hoặc bạn nhập chưa chính xác địa chỉ URL. 
          Vui lòng kiểm tra lại đường dẫn hoặc quay về trang chủ.
        </p>
        <div className="not-found-actions d-flex justify-content-center gap-3 flex-wrap">
          <Link to="/" className="btn-home-primary">
            <i className="bi bi-house-door-fill me-2"></i>
            Quay về trang chủ
          </Link>
          <button type="button" onClick={() => window.history.back()} className="btn-home-secondary">
            <i className="bi bi-arrow-left me-2"></i>
            Quay lại trang trước
          </button>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
